import Site2 from '@/shared/app/model/templating/Site2';
import FournierMobalpaThones from './1_fournier_mobalpa_thones';
import FournierMobalpaMetzTessy from './2_fournier_mobalpa_metz_tessy';
import ItecBoisFleury from './3_itec_boisfleury';
import GegGrenoble from './4_geg_grenoble';
import ArkemaMarseille from './5_arkema_marseille';
import ConseilClermont from './6_conseil_clermont';
import AguettantLyon from './7_aguettant_lyon';
import { defaultSite } from './default.site';

const sites: Site2[] = [
  /* 0 */
  defaultSite,
  /* 1 */
  FournierMobalpaThones,
  /* 2 */
  FournierMobalpaMetzTessy,
  /* 3 */
  ItecBoisFleury,
  /* 4 */
  GegGrenoble,
  /* 5 */
  ArkemaMarseille,
  /* 6 */
  ConseilClermont,
  /* 7 */
  AguettantLyon,
];

export default sites;
